import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-551f50ff")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "language-selection flex items-center justify-center",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$i18n.locale === 'pl' ? (_ctx.$i18n.locale = 'en') : (_ctx.$i18n.locale = 'pl')))
  }, _toDisplayString(_ctx.$i18n.locale === 'pl' ? 'EN' : 'PL'), 1))
})